import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
// components
import SearchInput from './SearchInput';
import SearchButton from './SearchButton';
import ChipList from 'shared/buttons/ChipList';
import useCurrentUser from 'shared/../hooks/useCurrentUser';

const SearchBox = ({
  visible,
  searchEntities = [],
}) => {
  const [text, setText] = useState('');
  const [items, setItems] = useState([]);
  const { hasAccessTo } = useCurrentUser();

  const onAdd = (item) => {
    setText('');
    if (items.includes(item) || item.trim() === '') {
      return;
    }
    setItems([...items, item]);
  };

  const onRemoveHandler = (item) => {
    const newItems = items.filter((i) => i !== item);
    setItems(newItems);
  };

  useEffect(() => {
    if (!visible) {
      setText('');
      setItems([]);
    }
  }, [visible]);

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef && inputRef.current && visible) {
      inputRef.current.focus();
    }
  }, [inputRef.current, visible]);

  const handleSearch = (button) => {
    const searchTerm = text.trim() === '' ? items : [...items, text.trim()];
    button.search(searchTerm);
  };

  const disabled = text === '' && items.length === 0;

  const searchDropdownClass = cn('search-dropdown', {
    visible,
  });

  return (
    <div className={searchDropdownClass}>
      <div className="row" style={{ width: '90%', margin: 'auto' }}>
        <SearchInput ref={inputRef} value={text} onChange={setText} onAdd={onAdd} />
      </div>
      <br />
      <ChipList data={items} onItemRemove={onRemoveHandler} />
      <div className="search-buttons-container">
        {searchEntities.map((x, index) => (hasAccessTo(x.role) ? <SearchButton disabled={disabled} id={x.id} key={index} title={x.title} onClick={() => handleSearch(x)} tooltip={x.tooltip} /> : null))}
      </div>
    </div>
  );
};

export default SearchBox;
